import ICompany from "../../models/ICompany";

export interface IContextState {
  company?: ICompany;
  companies: Array<ICompany>;
}

export const SET_COMPANY = "CONTEXT_SET_COMPANY";
export const SET_AVAILABLE_COMPANIES = "CONTEXT_SET_AVAILABLE_COMPANIES";

export type ActionTypes = typeof SET_COMPANY | typeof SET_AVAILABLE_COMPANIES;

export interface IContextAction {
  type: ActionTypes;
  payload: {
    company?: ICompany;
    companies?: Array<ICompany>;
  };
}
